export class UISupplierContext {
    SupplierId: number;
    SupplierCode: string;
    Name: string;

    constructor() {}
}
